import React, { forwardRef } from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { NumericFormat } from 'react-number-format';
interface NumericFormatFieldProps extends Omit<TextFieldProps, 'onChange' | 'defaultValue' | 'type'> {
  onValueChange?: (values: { value: string; floatValue: number | undefined }) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  decimalScale?: number;
  thousandSeparator?: string;
  prefix?: string;
  suffix?: string;
  allowNegative?: boolean;
  allowLeadingZeros?: boolean;
  decimalSeparator?: string;
  fixedDecimalScale?: boolean;
  valueIsNumericString?: boolean;
  defaultValue?: string | number;
  value?: string | number;
  textAlign?: 'left' | 'center' | 'right';
  displayType?: 'text' | 'input';
  renderText?: (value: string) => React.ReactNode;
}

const NumericFormatField = forwardRef<HTMLInputElement, NumericFormatFieldProps>(
  ({ 
    onValueChange, 
    onChange,
    decimalScale = 0,
    thousandSeparator = '.',
    prefix = '',
    suffix = '',
    allowNegative = false,
    allowLeadingZeros = false,
    decimalSeparator = ',',
    fixedDecimalScale = false,
    valueIsNumericString = false,
    textAlign,
    displayType = 'input',
    renderText,
    ...textFieldProps 
  }, ref) => {
    return (
      <NumericFormat
        customInput={displayType === 'text' ? undefined : TextField}
        getInputRef={ref}
        onValueChange={onValueChange}
        onChange={onChange}
        decimalScale={decimalScale}
        thousandSeparator={thousandSeparator}
        prefix={prefix}
        suffix={suffix}
        allowNegative={allowNegative}
        allowLeadingZeros={allowLeadingZeros}
        decimalSeparator={decimalSeparator}
        fixedDecimalScale={fixedDecimalScale}
        valueIsNumericString={valueIsNumericString}
        displayType={displayType}
        renderText={renderText}
        {...(displayType === 'text' ? {
          style: { 
            textAlign,
            display: 'block',
            width: '100%'
          },
          ...textFieldProps
        } : {
          ...textFieldProps,
          sx: {
            ...textFieldProps.sx,
            ...(textAlign && {
              '& .MuiInputBase-input': {
                textAlign: textAlign
              }
            })
          }
        })}
      />
    );
  }
);

NumericFormatField.displayName = 'NumericFormatField';

export default NumericFormatField;
